import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=36329b50&scoped=true"
import script from "./BaseSwitch.vue?vue&type=script&lang=ts"
export * from "./BaseSwitch.vue?vue&type=script&lang=ts"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=36329b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36329b50",
  null
  
)

export default component.exports